module.exports = __webpack_public_path__ + "img/IMG_8157_L_Black.5bf6b12e.jpg";